(function () {
  const initFooter = () => {
    const menus = document.querySelectorAll('[data-action="toggle-menu-footer"]');
    
    if (menus.length > 0) {
      menus.forEach((menu) => {
        // Remove existing listener to avoid duplicates in theme editor
        menu.removeEventListener('click', toggleMenu);
        menu.addEventListener('click', toggleMenu);
      });
    }
  };

  const toggleMenu = (event) => {
    const menu = event.currentTarget;
    menu.classList.toggle('-open');
  };

  document.addEventListener('DOMContentLoaded', initFooter);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFooter);
  }
})();
